"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../config/constants"));
var actions_1 = require("../../redux/reducers/profile/actions");
var framework_1 = require("../../widgets/framework");
var menu_1 = __importStar(require("./menu"));
var CompleteProfileModal_1 = __importDefault(require("./profile/completeprofile/CompleteProfileModal"));
var TermsOfUseUpdateModal_1 = __importDefault(require("./profile/completeprofile/TermsOfUseUpdateModal"));
var styles_1 = __importDefault(require("./styles"));
var SettingsScreen = function (_a) {
    var _b = _a.showHeadingTitle, showHeadingTitle = _b === void 0 ? true : _b;
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var isMobile = (0, core_1.useMediaQuery)(theme.breakpoints.down('sm'));
    var userProfile = (0, react_redux_1.useSelector)(function (state) { return state.profile; }).userProfile;
    var _c = (0, react_1.useState)(menu_1.default[0]), selectedSection = _c[0], setSelectedSection = _c[1];
    var _d = (0, react_1.useState)(false), showCompleteProfileModal = _d[0], setShowCompleteProfileModal = _d[1];
    var _e = (0, react_1.useState)(false), showTermsOfUseUpdateModal = _e[0], setShowTermsOfUseUpdateModal = _e[1];
    var _f = (0, react_1.useState)(false), tosChecked = _f[0], setTosChecked = _f[1];
    var _g = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _g.isAuthenticated, isRestricted = _g.isRestricted, authenticating = _g.authenticating;
    var checkTermsAndConditions = (0, react_redux_1.useSelector)(function (state) { return state.profile; }).checkTermsAndConditions;
    (0, react_1.useEffect)(function () {
        if (!isLoggedIn && !authenticating) {
            redirectToLogin();
        }
        else if (isLoggedIn && isRestricted) {
            dispatch((0, actions_1.getProfile)());
            setShowCompleteProfileModal(true);
        }
        else if (isLoggedIn && !authenticating) {
            dispatch((0, actions_1.getProfile)());
            if (!checkTermsAndConditions && constants_1.default.CHECK_TERMS_AND_CONDITIONS_ENABLED) {
                setShowTermsOfUseUpdateModal(true);
            }
        }
    }, [isLoggedIn, authenticating]);
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var renderListItem = function (menuItem, index, indent) {
        var _a;
        if (indent === void 0) { indent = 0; }
        var key = menuItem.key, title = menuItem.title, subMenu = menuItem.subMenu;
        var isSelected = selectedSection && selectedSection.key === key;
        var onSelect = function () { return setSelectedSection(menuItem); };
        return (react_1.default.createElement(react_1.default.Fragment, { key: "".concat(key, "_fragment_side") },
            react_1.default.createElement(core_1.ListItem, { key: key, button: true, selected: isSelected, onClick: onSelect, className: (0, classnames_1.default)((_a = {},
                    _a[classes.selectedListItem] = isSelected,
                    _a)) },
                react_1.default.createElement(core_1.ListItemText, { primaryTypographyProps: {
                        style: {
                            marginLeft: indent * 8
                        },
                        variant: 'body2'
                    }, primary: title }),
                isSelected && react_1.default.createElement(icons_1.ChevronRight, { role: "img", "aria-label": "menuItem".concat(index).concat(indent) })), subMenu === null || subMenu === void 0 ? void 0 :
            subMenu.map(function (item, i) { return renderListItem(item, i, 2); })));
    };
    var selectSection = function (event) {
        var value = event.target.value;
        var menuItem = (0, menu_1.findInMenuItems)(value);
        if (menuItem) {
            setSelectedSection(menuItem);
        }
    };
    var SectionComponent = selectedSection.component;
    if (Object.keys(userProfile).length === 0) {
        return (react_1.default.createElement(package_1.AppSpinner, { label: 'Loading Profile', customStyles: {
                backgroundColor: 'transparent'
            } }));
    }
    var customSubheader = showHeadingTitle ? (react_1.default.createElement(core_1.Typography, { variant: "h6", component: "h1", className: classes.menuHeader }, "Settings")) : (undefined);
    var onCloseModal = function () {
        setShowCompleteProfileModal(false);
    };
    var onSubmitTos = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_1.updateTermsAndConditions)())];
                case 1:
                    _a.sent();
                    return [4, dispatch((0, actions_1.fetchTermsAndConditions)())];
                case 2:
                    _a.sent();
                    setShowTermsOfUseUpdateModal(false);
                    return [2];
            }
        });
    }); };
    var handleTosChecked = function () {
        setTosChecked(!tosChecked);
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3, className: classes.grid },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 8, md: 4, lg: 4 },
                react_1.default.createElement(core_1.Card, null, isMobile ? (react_1.default.createElement("div", { className: classes.menu },
                    react_1.default.createElement(core_1.Typography, { variant: "h6", className: classes.menuHeader }, "Settings"),
                    react_1.default.createElement("div", { className: classes.menuSelectSection },
                        react_1.default.createElement(core_1.Select, { className: classes.menuSelect, value: selectedSection.key, onChange: selectSection, input: react_1.default.createElement(core_1.FilledInput, { name: "menu-item" }) }, menu_1.default.map(function (menuItem) { return (react_1.default.createElement(core_1.MenuItem, { key: menuItem.key, value: menuItem.key }, menuItem.title)); }))))) : (react_1.default.createElement(core_1.List, { component: "nav", subheader: customSubheader }, menu_1.default.map(function (menuItem, index) { return renderListItem(menuItem, index); }))))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8 },
                showHeadingTitle && (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, direction: "row" },
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Typography, { variant: "h4", component: "p", className: classes.pageHeader }, selectedSection.title)))),
                react_1.default.createElement(core_1.Card, { className: classes.page },
                    react_1.default.createElement(SectionComponent, { changeSection: setSelectedSection }))),
            react_1.default.createElement(CompleteProfileModal_1.default, { show: showCompleteProfileModal, onClick: onCloseModal, onClose: onCloseModal }),
            react_1.default.createElement(TermsOfUseUpdateModal_1.default, { show: showTermsOfUseUpdateModal, tosChecked: tosChecked, onSubmitTos: onSubmitTos, handleTosChecked: handleTosChecked }))));
};
exports.default = SettingsScreen;
//# sourceMappingURL=index.js.map